import { useFetchDepartmentEmployees } from './use-fetch-department-employees';
import { useFetchDepartments } from './use-fetch-departments';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export const useFetchEmployeesByDepartment = () => {
  const { values, setFieldValue } = useFormikContext();
  if (!values['setores']) {
    throw new Error(
      'Você precisa incluir pelo menos um array vazio "setores" nos valores iniciais do formulário'
    );
  }
  const { departments, loading: loadingDepartments } = useFetchDepartments();
  const { employees, loading: loadingEmployees } = useFetchDepartmentEmployees(values['setores']);

  let loading = loadingEmployees || loadingDepartments;

  useEffect(() => {
    setFieldValue('usuarios', []);
    //eslint-disable-next-line
  }, [values['setores']]);

  return {
    loading,
    employees,
    departments,
  };
};
